import { Controller } from "@hotwired/stimulus"

// Folds the rows of one group of the Berichtezentrale's Auswertung in and out. State lives in the
// DOM only: a reload (another page, another filter) shows every group open again, and the
// subtotal on the header row stays visible while its rows are folded.
export default class extends Controller {
  static targets = ["header", "row"]

  toggle(event) {
    const header = event.currentTarget
    const groupId = header.dataset.groupId
    const expanded = header.getAttribute("aria-expanded") !== "false"

    header.setAttribute("aria-expanded", String(!expanded))
    header.querySelector("[data-caret]")?.classList.toggle("-rotate-90", expanded)
    this.rowTargets
      .filter((row) => row.dataset.groupId === groupId)
      .forEach((row) => row.classList.toggle("hidden", expanded))
  }
}
